module.exports = __webpack_public_path__ + "assets/img/MyBoxBtn.49963f6d.png";